import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Navigate, useParams } from 'react-router-dom';
import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import { parseJSON, toJSON } from '../../utils/helpers';

const Action = () => {
  const dispatch = useDispatch();
  const { action_id } = useParams();

  const { action } = useSelector((state) => state.general);

  const [changeKeyValue, setChangeKeyValue] = useState(null);

  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'action',
        route: `actions/getactionById`,
        actionId: action_id,
      }),
    );
  }, [dispatch, action_id]);

  if (action?._id !== action_id) {
    dispatch(
      generalSet({
        reduxField: 'action',
        value: null,
      }),
    );
  }

  if (!action?._id) {
    return <Spinner />;
  }

  if (action?.actionType === 'DUPLICATE_CAMPAIGN' || action?.actionType === 'DUPLICATE_DIFF_ACCOUNT') {
    return <Navigate to={`/DuplicateCampaignAction/${action_id}`} />;
  }
  if (action?.actionType === 'CHANGE_BUDGET') {
    return <Navigate to={`/EditChangeDailyBudget/${action_id}`} />;
  }
  if (action?.actionType === 'CHANGE_BID_AMOUNT') {
    return <Navigate to={`/EditChangeBidAmount/${action_id}`} />;
  }
  if (action?.actionType === 'CHANGE_ROAS_BID_CONSTRAINTS') {
    return <Navigate to={`/EditChangeRoasBidConstraints/${action_id}`} />;
  }

  return action?._id ? (
    <>
      {(() => {
        const actionData = parseJSON(action.actionData);
        console.log({ action, actionData });
        const entries = Object.entries(actionData);
        return (
          <>
            <div>
              <Link className='btn btn-outline-dark' to='/actions'>
                Back to Actions
              </Link>
            </div>
            <div className='container mb-4' data-aos='fade-up' data-aos-delay='200'>
              <div className='row d-flex justify-content-center pt-4 pt-lg-0'>
                <div className='col-lg-12 d-flex justify-content-center mt-4 pt-lg-0'>
                  <h1>
                    Action Details: <span className='text-primary'>{actionData.name}</span>
                  </h1>
                </div>
                <div className='col-lg-12 d-flex justify-content-center mt-4 pt-lg-0 border-bottom'>
                  <h5>
                    Action Type: <span className='text-primary'>{action.actionType}</span>
                  </h5>
                </div>
              </div>
              <div className='row d-flex justify-content-center pt-4 pt-lg-0'>
                {entries.map(([key, value]) => {
                  if (action.actionType === 'CHANGE_STATUS' && key === 'status') {
                    return (
                      <div key={key} className='col-lg-3 d-flex justify-content-center mt-4 pt-lg-0 border-bottom'>
                        <b className='mr-2'>{key}: </b>
                        <select
                          type='text'
                          className='form-control select'
                          placeholder='Action name...'
                          defaultValue={value}
                          style={{ textAlign: 'center' }}
                          onChange={(e) => {
                            dispatch(
                              apiAction({
                                reduxField: 'action',
                                route: `actions/updateActionById`,
                                actionId: action_id,
                                actionData: { ...actionData, [key]: e.target.value },
                              }),
                            );
                            dispatch(
                              generalSet({
                                reduxField: 'action',
                                value: { ...action, actionData: toJSON({ ...actionData, [key]: e.target.value }) },
                              }),
                            );
                          }}
                        >
                          <option value='ACTIVE'>ACTIVE</option>
                          <option value='PAUSED'>PAUSED</option>
                          <option value='ARCHIVED'>ARCHIVED</option>
                        </select>
                      </div>
                    );
                  }
                  if (action.actionType === 'CHANGE_BUDGET' && key === 'unit') {
                    return (
                      <div key={key} className='col-lg-3 d-flex justify-content-center mt-4 pt-lg-0 border-bottom'>
                        <b className='mr-2'>{key}: </b>
                        <select
                          type='text'
                          className='form-control select'
                          placeholder='Action name...'
                          defaultValue={value}
                          style={{ textAlign: 'center' }}
                          onChange={(e) => {
                            dispatch(
                              apiAction({
                                reduxField: 'action',
                                route: `actions/updateActionById`,
                                actionId: action_id,
                                actionData: { ...actionData, [key]: e.target.value },
                              }),
                            );
                            dispatch(
                              generalSet({
                                reduxField: 'action',
                                value: { ...action, actionData: toJSON({ ...actionData, [key]: e.target.value }) },
                              }),
                            );
                          }}
                        >
                          <option value='percentage'>Percentage</option>
                          <option value='amount'>Amount</option>
                        </select>
                      </div>
                    );
                  }
                  return (
                    <div key={key} className='col-lg-3 d-flex justify-content-center mt-4 pt-lg-0 border-bottom'>
                      <b className='mr-2'>{key}: </b>
                      {changeKeyValue === key ? (
                        <input
                          type='text'
                          defaultValue={value}
                          onBlur={(e) => {
                            setChangeKeyValue(null);
                            dispatch(
                              apiAction({
                                reduxField: 'action',
                                route: `actions/updateActionById`,
                                actionId: action_id,
                                actionData: { ...actionData, [key]: e.target.value },
                              }),
                            );
                            dispatch(
                              generalSet({
                                reduxField: 'action',
                                value: { ...action, actionData: toJSON({ ...actionData, [key]: e.target.value }) },
                              }),
                            );
                          }}
                        />
                      ) : (
                        <span className='pointer' onClick={() => setChangeKeyValue(key)}>
                          {value}
                        </span>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        );
      })()}
    </>
  ) : (
    <Spinner />
  );
};

export default Action;
